import { fonts, dims, colors } from "../../../styles";

export default {
  container: {
    fontSize: 14,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontFamily: fonts.paragraph,
    width: "100%",
    height: dims.nav,
    letterSpacing: "0.4px",
    flexWrap: "wrap",
    marginTop: 16,
    paddingBottom: 16,
  },
  contact: {
    color: colors.white,
    letterSpacing: "1px",
    display: "flex",
    margin: "0 8px",
  },
  icon: {
    color: colors.lightGrey,
    marginRight: 8,
    fontSize: 18,
  },
};



// WEBPACK FOOTER //
// ./src/components/Layout/Footer/styles.js